import Vue from 'vue'
import store from './store'
import Router from 'vue-router'

import Home from './views/Home'
import Site from './views/Site'
import Company from './views/Company'

Vue.use(Router)

import { NAME, BASE_URL } from '@/constants'

const router = new Router({
    base: BASE_URL,
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: { requireAuth: true }
        },
        {
            path: '/site/:id_site',
            name: 'site',
            component: Site,
            meta: { requireAuth: true }
        },
        {
            path: '/company/:id_customer',
            name: 'company',
            component: Company,
            meta: { requireAuth: true }
        }
    ]
})

router.beforeEach((to, from, next) => {
    store.dispatch('init')
    .then(() => {
        if ('title' in to.meta) {
            document.title = to.meta.title
        } else {
            document.title = NAME
        }
        next()
    }).catch((error) => {
        console.error("beforeEach error:", error)
    })
})

export default router
